import { render, staticRenderFns } from "./InlineRating.vue?vue&type=template&id=6335374c"
import script from "./InlineRating.vue?vue&type=script&lang=js"
export * from "./InlineRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports